<script setup lang="ts">
defineProps<{
  label?: string
  name: string
}>()
</script>

<template>
  <div
    class="has-checked:text-neon-yellow inline-flex border border-black/50 font-mono text-sm uppercase has-checked:bg-black"
  >
    <label class="cursor-pointer p-3" :for="name + label">{{ label }}</label>
    <input :id="name + label" type="radio" :value="label" :name="name" class="sr-only" />
  </div>
</template>
